export default "__VITE_PUBLIC_ASSET__5228381b__"